import React from 'react';

export function SquadHeader({ eventName, squadNumber }) {
  return (
    <>
      <h1 className="mb-2 text-3xl font-bold text-white">
        {eventName}
      </h1>
      <h2 className="mb-6 text-xl font-semibold text-gray-300">
        Squad {squadNumber}
      </h2>
    </>
  );
}
